Vue.component('modal-receipt', {
    components: {
    },

    data() {
        return {
            reservationDisplayed: apr.reservationDisplayed,
            reservationAmount: apr.reservationAmount,
        }
    },

    mounted() {
        if (this.$ldClient && this.$ldClient.client && this.reservationDisplayed === 'N') {
            this.$ldClient.client.waitUntilReady().then(() => {
                this.$ldClient.client.track('purchase');
                this.$ldClient.client.track('purchase_amount', null, this.reservationAmount);
            });
        }

        try {
            localStorage.removeItem('webCouponCode');
        } catch {
            // no-op
        }
    },
});
